import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { adminLogin } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminLogin(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar showAnnouncement={false} />
      <section className="pt-32 pb-24 max-w-md mx-auto px-6">
        <p className="eyebrow text-blue-600 mb-3">Admin</p>
        <h1 className="font-display text-4xl md:text-5xl font-medium tracking-tighter text-slate-900">Sign in.</h1>
        <p className="mt-3 text-slate-600">Manage applications, impact stats and showcase projects.</p>

        <form onSubmit={onSubmit} className="mt-10 space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-[13px] font-medium text-slate-700">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-2 w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-[15px] focus:outline-none focus:border-blue-600 focus:bg-white"
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="text-[13px] font-medium text-slate-700">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-2 w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-[15px] focus:outline-none focus:border-blue-600 focus:bg-white"
              data-testid="admin-login-password"
            />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="admin-login-submit">
            {loading ? "Signing in..." : "Sign in"} {!loading && <ArrowRight size={18} />}
          </button>
        </form>
        <Link to="/" className="mt-8 inline-block text-slate-500 hover:text-slate-900 text-[14px]">← Back to site</Link>
      </section>
      <Footer />
    </div>
  );
}
